<template lang="pug">
  .district-results(v-if="district")
    .district-results_header( :class="{ called: statusData && statusData?.called }", :style="{ color: statusData && statusData.color }")
      .district-results_kicker(v-if="(isLive || statusData)")
        span.district-results_kicker_election
          span {{ currentElection.navLabel || year }}
        span.district-results_kicker_live(v-if="isLive")
          span LIVE
        span.district-results_kicker_called(v-if="statusData && statusData.text")
          span {{ statusData.text }}
        span.district-results_kicker_flipped(v-if="isFlipped")
          span|Flip

      //- .district-results_elected_member_avatar(v-if="statusData && statusData.called")
      //- 	//- {{ statusData.initials }}
      //- 	.district-results_elected_member_avatar_image(:class="{ hasImage: Boolean(avatar) }", :style="{ backgroundImage: avatar ? `url(${avatar})` : 'none' }")


      .district-results_title
        h3
          span.district_name {{ title.name }}
          span.district_state(v-if="title.state") , {{ title.state }}

      .district-results_header_info
        span.elected_member(v-if="statusData")
          //- span.elected_member_prefix {{ statusData.prefix }}
          span.elected_member_name {{ statusData.name || 'Seat still in doubt' }}
        span.pccounted(v-if="percentCounted > 0") {{ percentCounted }}% counted.
        a.live-results-link(v-if="indexUrl && !isApp", :href="indexUrl", @click="resultsLinkClick") See all live results

    .district-results_content
      template(v-if="show2cpBar && TwoCandidatePreferred")
        .district-results_subtitle
          h4 {{ TwoCandidatePreferredHeading }}
          span.district-results_2cp_margin(v-if="margin")
            span Margin: {{ margin }}
            span.district-results_pc_suffix %
        .district-results_2cp_names
          .district-results_2cp_names_item(
            v-for="(candidate, i) in TwoCandidatePreferred",
            :key="i", :party="candidate.affiliation.code",
            :style="{ 'color': partyColors[candidate.affiliation.code] }"
          )
            h4.district-results_2cp_names_text {{ candidate.affiliation.twoPPName || candidate.affiliation.shortName || candidate.affiliation.displayCode || candidate.affiliation.name }}
        .district-results_2cp_bar
          .district-results_2cp_bar_item(
              v-for="(candidate, i) in TwoCandidatePreferred",
              :key="i", :party="candidate.affiliation.code",
              :style="{ '--party-color': partyColors[candidate.affiliation.code], 'flex-basis': (candidate.Votes.Percentage ? candidate.Votes.Percentage : 50) + '%', 'width': (candidate.Votes.Percentage ? candidate.Votes.Percentage : 50) + '%'}"
            )

            .district-results_2cp_bar_text
              .district-results_2cp_bar_percent(:title="candidate.Votes.Count + ' Votes'")
                span {{ candidate.Votes.Percentage }}
                span.district-results_pc_suffix %
    
      .district-results_subtitle(v-if="candidates")
        h4 First Preference Votes
      .district-results_primary(v-if="candidates")
        .district-results_primary_parties
          .district-results_primary_candidate(
            v-for="(candidate, i) in candidates",
            :key="i",
          )
            .district-results_primary_candidate_party(
              :title="candidate.affiliation.name"
            ) {{ candidate.partyShortName || candidate.affiliation.code }}
        .district-results_primary_details
          .district-results_primary_candidate(
            v-for="(candidate, i) in candidates",
            :key="i",
            :party="candidate.affiliation.code",
            :style="{ '--party-color': candidate.color, '--party-color-light': candidate.colorLight, '--party-color-dark': candidate.colorDark, '--party-color-bright': candidate.colorBright }"
          )

            .district-results_primary_candidate_data
              .district-results_primary_candidate_bar
                .district-results_primary_candidate_bar_track
                .district-results_primary_candidate_bar_progress(:style="{ 'width': candidate.Votes.Percentage * 1.4	 + '%'}")
              .district-results_primary_candidate_details
                .district-results_primary_candidate_name(:title="(candidate.givenNames + ' ' + candidate.surname)" )
                  template(v-if="(candidate.givenNames && candidate.surname)")
                    span.firstname {{ candidate.givenNames }}&nbsp;
                    span.lastname {{ candidate.surname }}

                  span.partyfullname(v-else) {{ candidate.affiliation.name }}
                  span.elected(v-if="candidate.Elected")  *
                .district-results_primary_candidate_votes(v-if="candidate.Votes.Count") {{ (candidate.Votes.Count).toLocaleString() }} votes
        .district-results_primary_percentages
          .district-results_primary_candidate(
            v-for="(candidate, i) in candidates",
            :key="i",
            :style="{ '--party-color': candidate.color }"
          )
            .district-results_primary_candidate_percent(:title="candidate.Votes.Count + ' Votes'")
                span.pc {{ (candidate.Votes.Percentage) }}
                span.district-results_pc_suffix %

</template>
<script>
import { rgb } from 'd3-color';
import eventTracking from '../../utils/eventTracking';
import Disclaimer from '../Disclaimer/Disclaimer';

const body = document.querySelector('body');

export default {
  name: 'DistrictDataTable',
  components: { Disclaimer },
  props: {
    district: {
      type: Object,
      default: () => ({})
    },
    calledSeatData: {
      type: Object,
    },
    isLive: {
      type: Boolean,
      default: false
    },
    embed: { type: Boolean },
    year: { }
  },
  data() {
    const image = new Image();
    image.onload = (e) => this.avatar = e.currentTarget && e.currentTarget.getAttribute('src');

    return {
      avatar: null,
      image,
      isApp: Boolean(window.DNA_APP_ENV) || (body && body.attributes && body.attributes.length === 0) || document.querySelector('.screenkit--embed-container'),
    };
  },
  created() {

  },
  computed: {
    currentElection() { return this.$store.getters.currentElection(this.year); },
    partyConfig() { return this.$store.getters.partyConfig(); },
    cardConfig() { return this.currentElection.cards || {}; },
    name() { return this.district['eml:ContestIdentifier']['eml:ContestName']; },
    title() {
      const name = this.name;
      const state = this.district.State;
      return {
        name, state
      };
    },
    results() {
      if (this.currentElection.isReferendum) {
        return this.district?.ProposalResults;   
      }
      return this.district?.FirstPreferences; 
    }, // FirstPrefs could be changed via a setting.
    TwoCandidatePreferred() {
      if (this.currentElection.isReferendum) {
        return this.district?.ProposalResults?.Option;   
      }
      return this.district?.TwoCandidatePreferred?.Candidate;
    },
    TwoCandidatePreferredHeading() {
      return this.currentElection.isReferendum ? 'Options' : 'Two-Party Preferred'
    },
    margin() {
      if (this.TwoCandidatePreferred) {
        const [ left, right ] = this.TwoCandidatePreferred;
        return (left && right) && Math.abs((left.Votes.Percentage - right.Votes.Percentage) / 2).toFixed(2);
      }
      return null;
    },
    candidates() {
      const partyNames = this.partyConfig;
      const partyColors = this.partyColors;
      return this.results?.Candidate?.map( candidate => {
        const color = partyColors[candidate.affiliation.code];

        const partyShortName = partyNames[candidate.affiliation.code] && partyNames[candidate.affiliation.code]?.shortName;
        const seatCardDisplayPartyName = partyShortName && (partyShortName.length < (candidate.affiliation.code?.length || 0)) ? partyShortName : candidate.affiliation.code;

        return {
          ...candidate,
          color,
          colorLight: rgb(color).copy({ opacity: 0.1 }),
          colorBright: rgb(color).brighter(0.1),
          colorDark: rgb(color).darker(0),
          partyShortName: seatCardDisplayPartyName,
        };
      } );
    },
    partyColors() { 		return this.$store.getters.partyColors(this.year); },
    percentCounted() { 	return this.results.Total.Votes.Percentage; },
    indexUrl() {
      const indexPageDomain = this.$store.getters.getIndexPageDomain();
      const indexPageUrl = this.$store.getters.getIndexPageUrl();
      const indexAbsLink = indexPageDomain && indexPageUrl ? `${ indexPageDomain }${ indexPageUrl }` : '';

      return this.embed ? indexAbsLink : '';
    },
    status() {

      const useSplitData = this.$store.getters.currentElection(this.year).useSplitData;

      if (useSplitData) {
        const statusKey = this.$store.getters.dataMasthead(this.year);

        return this.district.ncaCalledStatus && this.district.ncaCalledStatus[statusKey];
      } else {
        return this.district.ncaCalledStatus || '';
      }
    },
    isFlipped() {
      const incumbentCandidate = this?.candidates?.slice().find( (candidate => candidate.Incumbent) );
      const partyMatchArr = [].concat(
        (incumbentCandidate?.affiliation?.groupCodes || []),
        (incumbentCandidate?.affiliation?.aliasCodes || []),
        [ incumbentCandidate?.affiliation?.code ],
      );

      // console.log('isCalled', incumbentCandidate?.surname, partyMatchArr, incumbentCandidate?.affiliation?.code, this.statusData, !partyMatchArr.includes(this.statusData?.party));

      if (this.statusData?.called && incumbentCandidate && !partyMatchArr.includes(this.statusData?.party)) {
        console.warn(`${ this.title.name } flipped from ${ incumbentCandidate?.surname } (${ incumbentCandidate?.affiliation?.code }) to ${ this.statusData?.party }`);
        return true;
      }
      return false;
    },
    statusData() {
      if (this.currentElection.isReferendum) return;

      let candidate, called;
      const isDeclared = Boolean(this.district.Declared);

      if (isDeclared) {
        candidate = this.candidates.slice().find( (candidate => candidate.Elected) );
        called = Boolean(candidate);
      } else if (this.status) {

        const [ , calledStatus ] = this.status?.match(/(.*)\s(?:gain|retain|win)/i) || [];
        const [ , partyCode ] = this.status?.match(/(.*)\s(?:gain|retain|likely|win)/i) || [];

        if (partyCode) {
          // Filter candidates to match party code. need to sort the array also incase there are multiple independents, so we choose the leading one.
          candidate = this.candidates.slice().sort( (a, b) => (b.Votes.Percentage - a.Votes.Percentage) ).find( (candidate => {
            const codes = [ ...candidate.affiliation.aliasCodes, candidate.affiliation.code ].join(',') ;
            return codes.match(partyCode);
          } ) );
          called = Boolean(candidate && calledStatus);
        }
      }

      const statusData = {
        text: this.status,
        called,
        color: candidate ? this.partyColors[candidate.affiliation.code] : '#333',
      };

      if (called) {
        const name = candidate.givenNames && candidate.surname ? `${ candidate.givenNames } ${ candidate.surname }, ${ candidate.affiliation.name }` : candidate.affiliation.name;
        const initials = `${ candidate.givenNames.charAt(0) }${ candidate.surname.charAt(0) }`;
        const prefix = isDeclared ? 'Declared for: ' : 'Called for: ';

        return {
          ...statusData,
          party: candidate.affiliation.code,
          color: this.partyColors[candidate.affiliation.code],
          name,
          prefix,
          initials,
        };
      }

      return statusData;
    },
    show2cpBar() {
      if (this.currentElection.isReferendum) {
        return this.cardConfig?.show2cpBar && this.TwoCandidatePreferred?.length;
      }

      return this.cardConfig?.show2cpBar &&
          this.TwoCandidatePreferred?.length &&
          this.TwoCandidatePreferred[0]?.Votes?.Count > 0 &&
          this.TwoCandidatePreferred[1]?.Votes?.Count > 0;
    },
    resultsLinkTrackingData() {
      const analyticsConfig = this.$store.getters.getAnalyticsConfig(this.year);

      return {
        ...analyticsConfig,
        label: 'electorate-detail',
        order: '1',
      };
    },
  },
  methods: {
    resultsLinkClick() {
      eventTracking(this.resultsLinkTrackingData);
    }
  }
};
</script>
<style lang="scss">
  @import "src/core/scss/global-sass";

  .district-results {
    @include font-base-m;
    @include thaustalianFonts();

    font-size: 14px;
    text-align: left;
    width: 100%;
    box-sizing: border-box;

    @include MQ_MediumLarge {
      flex: 1;
      flex-basis: 100%;
      display: flex;
      flex-direction:column;
    }

    .eui-disclaimer {
      border: 0;
      padding-bottom: 0;
    }

    &_pc_suffix {
      font-size: 0.75em;
    }

    &_header {
      background: #fff;
      flex: 0;
      padding-bottom: $m-spacing;
      border-bottom: 1px solid #ccc;
      padding: #{$card-spacing * 2};
      transition: color 0.3s;
      border-top: 3px solid #eee;
      margin-top: -1px;

      &.called {
        transition: color 0.3s;
        color: #ddd;
        border-top: 3px solid currentColor;

      }

      &_info {
        text-transform: none;color: #666;
        font-size: 12px;
        font-weight:normal; line-height: 1.2;
        padding-top: 4px;

        .live-results-link {

        }

        .pccounted {
          margin-right: $m-spacing;
        }

        .elected_member {
          display: block;
          padding-bottom: #{$card-spacing / 2};

          &_prefix {
            font-weight: bold;
          }
        }
      }
    }

    &_kicker {
      margin-bottom: 10px;
      margin-top: -4px;

      > span {
        border-radius: 10px;
        padding: 3px #{$m-spacing-x3};
        font-size: 11px;
        display: inline-block;
        align-items: center;
        line-height: 16px;
        text-transform: uppercase;
        margin-right: $m-spacing;

        span {
          color: #fff;
        }
      }

      &_live {
        background-color: #dc5544;
        animation: kickerOpacity 2.5s infinite ease-out 2s alternate;
      }

      &_called {
        background-color: currentColor;
      }

      &_election {
        background-color: #333;
      }

      &_flipped {
        background-color: var(--highlight-color);
        // background: repeating-linear-gradient(-45deg, var(--highlight-color), var(--highlight-color) 8px,  #004593 8px, #004593 16px)
      }
    }

    &_content {
      background: #fff;
      overflow: auto;
      padding: #{$card-spacing * 2};

      @include MQ_MediumLarge {
        display: flex;
        flex-direction:column;
        flex: 1;
        flex-basis: 100%;
      }

      @include MQ_SmallOnly() {
        overflow: initial;
      }
    }

    & &_title {
      display: flex;
      flex: 1;
      flex-direction: column;
      line-height: 1.2;
      margin-bottom: #{$card-spacing / 2};

      h3 {
        text-transform: none; margin: 0; color: #000; line-height: 1;

        @include font-title-m;
        @include thaustalianFonts();
      }

      // .district_name {
      // 	display: inline-block;
      // }
      .district_state {
        text-transform:capitalize;
      }
    }

    & &_subtitle {
      padding-top: var(--spacing-unit-x3);
      padding-bottom: var(--spacing-unit);
      display: flex;
      align-items: baseline;
      justify-content: space-between;

      &:first-child {
        padding-top: 0;
      }

      h4 {
        margin: 0; text-transform: initial; font-size: 14px;
        display:flex; justify-content: space-between; align-items: center;
        color: var(--color-title);

        @include MQ_LT(1010px) {
          flex-direction: column;
          align-items: flex-start;
        }

        @include font-title-xs;
        @include thaustalianFonts();
      }
    }


    &_elected_member_avatar {
      position: relative;
      float:right;
      width: 46px;
      height: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;

      font-size: 20px;
      border: 2px solid currentColor;

      span {
        padding-top: 2px;
      }

      background-image: url("https://media.theaustralian.com.au/election/dinkus/anon.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;

      &_image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        transition: opacity 0.3s 0.1s, background-image 0.3s 0.1s;
        opacity: 0;

        &.hasImage {
          opacity: 1;
        }
      }

      .tooltip & {
        margin-right: 20px;
      }
    }

    .tooltip &_kicker + &_elected_member_avatar {
      margin-right: 0;
    }


  // Primary Votes table
  // -------------------

  &_primary {
    display: flex;

    @include MQ_MediumLarge {
      line-height: 0.8rem;
    }
    @include MQ_SmallOnly() {
      line-height: 13px;
    }

    &_parties {
      flex: 0;
      padding-right: var(--spacing-unit-x2);
      font-weight: bold;
    }

    &_details {
      flex: 1;
    }

    &_percentages {

      font-size: 18px;
      white-space: nowrap;
      padding-left: var(--spacing-unit-x2);
    }

    &_candidate {
      display: flex;
      justify-content: stretch;
      align-items: flex-start;
      margin-top: var(--spacing-unit-x1_5);
      height: 34px;

      --bar-height: 6px;

      .screenkit--embed-container & {
        max-height: 40px;
      }

      &_data {
        flex: 1;
      }

      &_bar {
        position: relative;
        height: var(--bar-height);
        border-radius: calc(var(--bar-height) / 2);
        overflow: hidden;
        margin: var(--bar-height) 0;

        &_track {
          height: 100%;
          background-color: var(--party-color-light, #eee);
        }

        &_progress {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 0%;
          background: var(--party-color-light, #eee) 0px 0px no-repeat;
          transition: width 0.3s 0.1s ease;
          background-image: linear-gradient(to right, var(--party-color-bright), var(--party-color-dark));
          border-radius: calc(var(--bar-height) / 2);
        }
      }

      &_details {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      &_party {
        line-height: calc(var(--bar-height) * 3);
      }

      &_name {
        font-size: 12px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space:nowrap;
      }

      &_votes {
        color: var(--color-body-alt);
        font-size: 12px;
      }

      &_percent {
        color: var(--party-color);
        line-height: calc(var(--bar-height) * 3);
      }
    }
  }

  // Two Party Preferred bar
  // -----------------------
  &_2cp {
    &_margin {
      // float:right;
      // margin-left: $m-spacing;
      font-weight: normal;
      color: var(--color-body-alt);
      font-size: 12px;
    }

    &_names {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-transform: uppercase;

      &_text {
        margin: 0;
        padding: 0 0 calc(var(--spacing-unit) / 2);
      }
    }

    &_bar {
      display: flex;
      justify-content: stretch;
      overflow: hidden;
      margin: 0 calc(var(--spacing-unit) * -1);
      height: 34px;
      flex: 0 0 34px;

      &_item {
        background: var(--party-color, #ddd);
        color: #fff;
        transition: all 0.3s 0.1s ease;
        position: relative;
        --border-radius: calc(var(--spacing-unit) * 3);

        &:first-child {
          text-align:left;
          border-radius: var(--border-radius) 0 0 var(--border-radius);
        }

        &:last-child {
          text-align:right;
          border-radius: 0 var(--border-radius) var(--border-radius) 0;
        }
      }

      &_item:last-child &_text {
        justify-content: flex-end;
        align-items: flex-end;
      }

      &_text {
        color: #fff;
        padding: var(--spacing-unit) var(--spacing-unit-x2);
        display: flex;
        align-items: center;
        position: relative;
        z-index: 2;
        flex-direction: column;
        align-items: flex-start;
        line-height: 1;
      }

      &_percent {
        font-weight: bold;
        font-size: 18px;
      }

      & &_name {
        white-space: nowrap;
        font-weight: bold;
        color: white;
        font-size: 1.1em;
        margin: 0;
      }
    }
  }

}


  // Tooltip styles
  // -----------------------

  div.tooltip {
    position: absolute;
    z-index: 999;
    background-color: white;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    color: currentColor;
    max-width: 99vw;
    box-sizing: border-box;
    opacity: 0;
    overflow-y: auto;

    &.visible {
      transition: opacity 0.3s ease;
      opacity: 1;
      display: flex;
    }

    &:empty {
      opacity: 0;
      pointer-events: none;
      padding:0;
      border:0;
    }

    &.flipX {
      transform: translateX(-100%);
    }

    // &.flipY {
    //   transform: translateY(-100%);
    // }

    &.notTouchDevice {
      &, * { pointer-events:none; }
    }

    .tooltip_close {
      top: 0;
      right: 0;
      padding: $m-spacing-x2;
      position: absolute;
      cursor: pointer;

      &,
      * {
        pointer-events:all;
      }

      svg { width: 16px; height: 16px; }

      &:hover {
        svg path { fill: #666; }
      }
    }


    @include MQ_TabletAndUp {
      min-width: 400px;
    }

    @include MQ_MobileTablet() {

      --site-header-offset: 60px;
      --ad-offset: 60px;
      --electorate-header-offset: 130px;

      overflow-y: auto;

      .district-results_content {
        overflow-y: auto;
      }

      &:not(.isH20App) {
        position: fixed;
        top: 50% !important;
        transform: translate(-50%, -50%) !important;
        left: 50% !important;
        max-height: 80vh;
        max-height: calc(100vh - var(--site-header-offset) - var(--ad-offset) - var(--spacing-unit-x2) );
      }

      &:not(.isH20App) .district-results_content {
        max-height: 50vh;
        max-height: calc(100vh - var(--site-header-offset) - var(--ad-offset) - var(--electorate-header-offset) - var(--spacing-unit-x2) );
      }

      &.isH20App {
        --site-header-offset: 50px;
        --ad-offset: 50px;
      }

      // &.isH20App  .district-results_content {
      //   max-height: calc(var(--screen-height, 600px) - var(--site-header-offset) - var(--ad-offset) - var(--electorate-header-offset) - var(--spacing-unit-x2));
      // }

      // visible styles

      &.visible {
        display: flex;
      }

      // TODO: move this into all seats
      &.visible {
        ~ .tooltip-overlay {
          position: absolute;
          background: white;
          opacity: 0.2;
          width: 100%;
          height:100%;
        }
        // ~ .all-results_content { transition: 0.3s ease; opacity:0.3; filter: blur(2px); }
      }
    }

    @include MQ_MobileOnly() {
      width: 90%;
      width: calc(100vw - var(--spacing-unit-x2));

      .map-group &.isH20App {
        left: 0 !important;
        top: 0 !important;
      }

      .all-results &.isH20App {
        margin-top: calc(var(--spacing-unit-x4) * -1);
        margin-left: var(--spacing-unit);
      }
    }
  }

</style>
